export default __webpack_public_path__ + "static/media/residentials.daf7204b.webp";